import * as React from 'react';

interface Props {}

const SvgIcon = ({}: Props): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="none" viewBox="0 0 100 100">
    <path
      fill="#D3E1FF"
      d="M95 60a5 5 0 0 1 5 5v20a15 15 0 0 1-15 15H15A15 15 0 0 1 0 85V65a5 5 0 1 1 10 0v20l.006.248A5 5 0 0 0 15 90h70a5 5 0 0 0 5-5V65a5 5 0 0 1 5-5M49.999 0q.207 0 .41.018l.08.006q.095.01.188.023l.045.005.196.033.045.01a5 5 0 0 1 .415.099l.059.016.17.056.063.02.157.06.078.03.11.048.133.06.08.04q.064.031.124.064l.105.059q.056.03.11.063l.133.083.06.038.133.092.084.06.07.054a5 5 0 0 1 .487.427l25 25.001a5 5 0 1 1-7.07 7.07L54.999 17.072V65a5 5 0 0 1-10 0V17.07L28.534 33.535a5 5 0 0 1-7.07-7.07l24.978-24.98q.188-.188.393-.357l.076-.06q.055-.044.11-.085l.075-.053q.167-.12.344-.226l.088-.05a5 5 0 0 1 .575-.282l.045-.017q.093-.038.188-.071l.033-.011q.1-.035.2-.065l.028-.007q.097-.03.195-.054l.07-.016q.088-.02.178-.038l.023-.005q.105-.02.212-.036l.042-.005.171-.021.032-.003.06-.005Q49.787 0 50 0"
    ></path>
  </svg>
);

export default SvgIcon;
